"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const scenario_variable_1 = require("./scenario-variable");
function isVariableRange(targetPop) {
    const [firstElement] = targetPop;
    return typeof firstElement === 'object' && firstElement !== null;
}
exports.isVariableRange = isVariableRange;
function isCategoricalMethod(scenarioVariable) {
    switch (scenarioVariable.method) {
        case scenario_variable_1.VariableMethods.RelativeScenarioCat:
        case scenario_variable_1.VariableMethods.TargetScenarioCat:
        case scenario_variable_1.VariableMethods.AbsoluteScenarioCat:
            return true;
    }
    return false;
}
exports.isCategoricalMethod = isCategoricalMethod;
function isComponentMethod(scenarioVariable) {
    switch (scenarioVariable.method) {
        case scenario_variable_1.VariableMethods.ComponentAttributionScenario:
        case scenario_variable_1.VariableMethods.ComponentTargetScenario:
        case scenario_variable_1.VariableMethods.ComponentAbsoluteScenario:
        case scenario_variable_1.VariableMethods.ComponentRelativeScenario:
            return true;
    }
    return false;
}
exports.isComponentMethod = isComponentMethod;
//# sourceMappingURL=scenario-type-service.js.map